export default __webpack_public_path__ + "static/media/Authentic-Sans-90.6bc0c161.woff2";